import { getConfig } from '../utilities';

const useMenuView = async() => {

  let configParmas = await getConfig(localStorage.getItem('path'))

  return configParmas;
}

export default useMenuView;